<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-menu-button data-test="menuButton" auto-hide="false"></ion-menu-button>
        </ion-buttons>
        <ion-title data-test="title">Tag Analysis</ion-title>
        <!-- <ion-buttons slot="end">
            <ion-button (click)="onActiveCampaignAddTagsClick()">
                <ion-icon name="add-circle-outline"></ion-icon>
            </ion-button>
            <ion-button (click)="onActiveCampaignDeleteTagsClick()">
                <ion-icon name="remove-circle-outline"></ion-icon>
            </ion-button>
        </ion-buttons> -->
    </ion-toolbar>
</ion-header>

<ion-content>
    <ion-list>
        @for (account of allAccounts; track $index) {
        <div class="container">
            <div class="header">
                <div class="dealership">{{account.profile.dealershipName}} - {{account.profile.accountNumber}}</div>
                <!-- <div>{{account.accountNumber}}</div>
                <div>Signup: {{account.profile.signupDate}}</div>
                <div>Expiration: {{account.profile.expirationDate}}</div> -->
                <ion-row>
                    <ion-col>
                        <span class="status">Status: {{account.profile.status}}</span>
                    </ion-col>
                    <ion-col class="justify-content-end">
                        <span class="dates">{{account.profile.signupDate}} thru
                            {{account.profile.expirationDate}}
                        </span>
                    </ion-col>
                </ion-row>
            </div>

            <div class="summary">
                <ion-row>
                    <ion-col size="2">Entity</ion-col>
                    <ion-col size="3">Days After Signup</ion-col>
                    <ion-col size="7">Count</ion-col>
                </ion-row>

                <ion-row>
                    <ion-col size="2">Shuttles</ion-col>
                    <ion-col size="3">{{account.summary.shuttlesDateInfo}}</ion-col>
                    <ion-col size="7">{{account.summary.shuttlesCount}}</ion-col>
                </ion-row>

                <ion-row>
                    <ion-col size="2">Users</ion-col>
                    <ion-col size="3">{{account.summary.usersDateInfo}}</ion-col>
                    <ion-col size="7">{{account.summary.usersCount}}</ion-col>
                </ion-row>

                <ion-row>
                    <ion-col size="2">Service Areas</ion-col>
                    <ion-col size="3">{{account.summary.serviceAreasDateInfo}}</ion-col>
                    <ion-col size="7">{{account.summary.serviceAreasCount}}</ion-col>
                </ion-row>

                <ion-row>
                    <ion-col size="2">Tickets</ion-col>
                    <ion-col size="3">{{account.summary.ticketsDateInfo}}</ion-col>
                    <ion-col size="7">{{account.summary.ticketsCount}}</ion-col>
                </ion-row>

                <ion-row>
                    <ion-col size="2">Trips</ion-col>
                    <ion-col size="3">{{account.summary.tripsDateInfo}}</ion-col>
                    <ion-col size="7">{{account.summary.tripsCount}}</ion-col>
                </ion-row>

                <ion-row>
                    <ion-col size="2">Campaigns</ion-col>
                    <ion-col size="3">{{account.summary.campaignsDateInfo}}</ion-col>
                    <ion-col size="7">{{account.summary.campaignsCount}}</ion-col>
                </ion-row>
            </div>

            <div class="tags">
                <ion-row>
                    <ion-col size="2">Tags</ion-col>
                    <ion-col size="10">{{account.tags.previous}}</ion-col>
                </ion-row>

                <ion-row>
                    <ion-col size="2">New Tags</ion-col>
                    <ion-col size="10">{{account.tags.suggested}}</ion-col>
                </ion-row>
            </div>
        </div>
        }





        <!-- 
        <ion-grid>
            <ion-row>
                <ion-col>
                    @for (account of allAccounts; track $index) {
  <ion-card class="default">
                        <ion-card-header>
                            <div>{{account.profile.dealershipName}}</div>
                            <div>Status: {{account.profile.status}}</div>
                            <div>{{account.profile.signupDate}}   thru   {{account.profile.expirationDate}}</div>
                        </ion-card-header>

                        <ion-card-content>
                            <ion-list lines="none">
                                <ion-row>
                                    <ion-col size="4">Entity</ion-col>
                                    <ion-col size="5">Days After Signup</ion-col>
                                    <ion-col size="3">Count</ion-col>
                                </ion-row>

                                <ion-row>
                                    <ion-col size="4">Shuttles</ion-col>
                                    <ion-col size="6">{{account.summary.shuttlesDateInfo}}</ion-col>
                                    <ion-col size="2" class="ion-align-self-end">{{account.summary.shuttlesCount}}</ion-col>
                                </ion-row>

                                <ion-row>
                                    <ion-col size="4">Users</ion-col>
                                    <ion-col size="6">{{account.summary.usersDateInfo}}</ion-col>
                                    <ion-col size="2">{{account.summary.usersCount}}</ion-col>
                                </ion-row>

                                <ion-row>
                                    <ion-col size="4">Service Areas</ion-col>
                                    <ion-col size="6">{{account.summary.serviceAreasDateInfo}}</ion-col>
                                    <ion-col size="2">{{account.summary.serviceAreasCount}}</ion-col>
                                </ion-row>

                                <ion-row>
                                    <ion-col size="4">Tickets</ion-col>
                                    <ion-col size="6">{{account.summary.ticketsDateInfo}}</ion-col>
                                    <ion-col size="2">{{account.summary.ticketsCount}}</ion-col>
                                </ion-row>

                                <ion-row>
                                    <ion-col size="4">Trips</ion-col>
                                    <ion-col size="6">{{account.summary.tripsDateInfo}}</ion-col>
                                    <ion-col size="2">{{account.summary.tripsCount}}</ion-col>
                                </ion-row>

                                <ion-row>
                                    <ion-col size="4">Campaigns</ion-col>
                                    <ion-col size="6">{{account.summary.campaignsDateInfo}}</ion-col>
                                    <ion-col size="2">{{account.summary.campaignsCount}}</ion-col>
                                </ion-row>

                            </ion-list>
                        </ion-card-content>
                        <ion-card-header>
                            <ion-row>
                                <ion-col size="4">Tags</ion-col>
                                <ion-col size="8">{{account.tags.previous}}</ion-col>
                            </ion-row>

                            <ion-row>
                                <ion-col size="4">New Tags</ion-col>
                                <ion-col size="8">{{account.tags.suggested}}</ion-col>
                            </ion-row>
                        </ion-card-header>

                    </ion-card>
}

                </ion-col>
            </ion-row>
        </ion-grid> -->
    </ion-list>
</ion-content>

<ion-footer>
    <ion-toolbar>
        <ion-grid>
            <ion-row>
                <ion-col>
                    <ion-button data-test="analyzeButton" color="primary" expand="full" (click)="onAnalyzeClick()">
                        Analyze
                    </ion-button>
                </ion-col>
                <ion-col>
                    <ion-button data-test="saveButton" color="primary" expand="full" (click)="onSaveClick()">
                        Save
                    </ion-button>
                </ion-col>
            </ion-row>
        </ion-grid>
    </ion-toolbar>
</ion-footer>